import { IComplaint } from "../../constants/commonTypes";
import { LoadState } from "../../constants/enums";

export interface IUserTransaction {
	user_prospect_id: number;
	olddb_tempid: number | null;
	user_name: string;
	contact_no: string;
	email_id: string;
	state: string;
	membership_code: string;
	city: string;
	area: string;
	address: string;
	gstin: string;
	vehicle_no: string;
	make_name: string;
	model_name: string;
	package_name: string;
	package_id: number;
	package_price: number;
	package_period: number;
	package_services: number;
	comment: string;
	payment_date: string;
	payment_mode: string;
	promo_code: string;
	referral_code: string;
	status: "ACTIVE" | "PENDING";
	hof_id: number | null;
	partner_id: number;
	gst_percentage: number;
	gst_amount: number;
	insert_dt: string;
	branch_office: string;
	vehicle_number: string;
	maker_name: string;
	total_services: number;
	used_services: number;
	contact_number: string;
	remain_services: number;
	membership_start_date: string;
	membership_expiry_date: string;
	new?: boolean;
}

export interface IManageMembership {
	user_name: string;
	contact_number: string;
	email_id: string;
	vehicle_number: string;
	maker_name: string;
	model_name: string;
	state: string;
	city: string;
	area: string;
	address: string;
	status: string;
	total_services: number;
	used_services: number;
	remain_services: number;
	membership_start_date: string;
	membership_expiry_date: string;
	branch_office: string;
	membership_code: string;
}

export interface IMechanicDashboardAnalytics {
	totalComplaints: number;
	totalComplaintCancelled: number;
	totalComplaintsClosed: number;
	totalComplaintsOpen: number;
}

// Dynamic API response structure
export interface IAnalyticsStatusCount {
	status: string;
	status_count: number;
}

export interface IAnalyticsApiResponse {
	totalRecords: IAnalyticsStatusCount[];
}

export interface 	IAnalyticsTrasistionCount{
	last_week: string;
	this_month: string;
	today: string;
	yesterday: string;

	
}

export interface IDashbaord {
	userTransactions: {
		transactionsByDate: {
			[key: string]:
			| {
				list: IUserTransaction[];
				count: number;
			}
			| undefined;
		};
	};
	complaints: {
		compaintsByDate: {
			[key: string]:
			| {
				list: IComplaint[];
				count: number;
			}
			| undefined;
		};
	};
	finance: {
		list: IUserTransaction[];


		totalRecords: number;
		totalAmount: number;
		error: string | null;
		loading: LoadState;
	}
	finance_analytics: {
		totalRecords: IAnalyticsTrasistionCount;
		loading: LoadState;
		error: string | null;
	}
	salesLead: {
		list: IUserTransaction[];
		totalAmount: number;
		totalRecords: number;
		error: string | null;
		loading: LoadState;
	}
	salesLead_analytics: {
		totalRecords: IAnalyticsTrasistionCount;
		loading: LoadState;
		error: string | null;
	}

	transactions: {
		list: IUserTransaction[];
		totalAmount: number;
		totalRecords: number;
		records: {
			currentRecords: number;
			totalPages: number;
			totalRecords: number;
		};
		error: string | null;
		loading: LoadState;
	},

	mechanicComplaint: {
		list: IComplaint[];
		amount: string;
		records: {
			currentRecords: number;
			totalPages: number;
			totalRecords: number;
		}
		totalRecords: number;
		error: string | null;
		loading: LoadState;
	},
	analytics: {
		data: IMechanicDashboardAnalytics;
		loading: LoadState;
		error: string | null;
	}
}

export const initialDashboard: IDashbaord = {
	userTransactions: {
		transactionsByDate: {},
	},
	complaints: {
		compaintsByDate: {},
	},
	finance: {
		list: [],
		totalAmount: 0,
		totalRecords: 0,
		error: null,
		loading: LoadState.NotLoaded
	},
	finance_analytics: {
		totalRecords: {
			last_week: "",
			this_month: "",
			today: "",
			yesterday: ""
		},
		loading: LoadState.NotLoaded,
		error: null
	},
	salesLead: {
		list: [],
		totalAmount: 0,
		totalRecords: 0,
		error: null,
		loading: LoadState.NotLoaded
	},
	salesLead_analytics: {
		totalRecords: {
			last_week: "",
			this_month: "",
			today: "",
			yesterday: ""
		},
		loading: LoadState.NotLoaded,
		error: null
	},
	transactions: {
		list: [],
		totalAmount: 0,
		totalRecords: 0,
		records: {
			currentRecords: 0,
			totalPages: 0,
			totalRecords: 0
		},
		error: null,
		loading: LoadState.NotLoaded
	},
	mechanicComplaint: {
		list: [],
		amount: "0",
		records: {
			currentRecords: 0,
			totalPages: 0,
			totalRecords: 0
		},
		totalRecords: 0,
		error: null,
		loading: LoadState.NotLoaded
	},
	analytics: {
		data: {
			totalComplaints: 0,
			totalComplaintCancelled: 0,
			totalComplaintsClosed: 0,
			totalComplaintsOpen: 0
		},
		loading: LoadState.NotLoaded,
		error: null
	}
};
